<template>
  <div className="animated">
    <b-card>
      <b-card-header>
        <i class="icon-menu mr-1"></i>Manage Balance
      </b-card-header>
      <b-card-body>
        <voucher-balance></voucher-balance>
      </b-card-body>
    </b-card>
  </div>
</template>

<script>
  import VoucherBalance from './Table'

  export default {
    name: 'voucher-manage-balance',
    components: {
      VoucherBalance
    }
  }
</script>

<style>
  #app {
    font-family: 'Avenir', Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    text-align: center;
    color: #2c3e50;
    margin-top: 60px;
  }
</style>
